<template>
    <form-section
        id="property"
        method="patch"
        :url="url"
        :read_only="read_only"
        v-slot="scope"
    >
        <property-mls
            :property="property_proxy"
            :read_only="read_only"
            @mlsDataReceived="updateMlsData"
        />

        <property-buyer-names
            :contacts="contacts"
            :read_only="read_only"
        />

        <property-address
            :property="property_proxy"
            :read_only="read_only"
        />

        <contract-acceptance-date
            v-model="contract_acceptance_date"
            :read_only="read_only"
        />
        <property-purchase-price
            :property="property_proxy"
            :read_only="read_only"
        />

        <property-pin
            :property="property_proxy"
            :read_only="read_only"
        />

        <property-images
            :images="property.images"
            :image_store_url="image_store_url"
            :read_only="read_only"
        />
    </form-section>
</template>

<script>
import ContractAcceptanceDate from '../shared/contract-acceptance-date.vue';
import FormSection from '../../components/form-section.vue';
import PropertyAddress from './property-address.vue';
import PropertyBuyerNames from './property-buyer-names.vue';
import PropertyImages from './property-images.vue';
import PropertyMls from './property-mls.vue';
import PropertyPin from './property-pin.vue';
import PropertyPurchasePrice from './property-purchase-price.vue';

export default {
    components: {
        ContractAcceptanceDate,
        FormSection,
        PropertyAddress,
        PropertyBuyerNames,
        PropertyImages,
        PropertyMls,
        PropertyPin,
        PropertyPurchasePrice,
    },

    props: {
        contacts: {},
        property: {},
        url: {},
        image_store_url: {},
        interests: {},
        read_only: { default: false },
    },

    data() {
        return {
            contract_acceptance_date: this.property.contract_acceptance_date,
            property_proxy: this.property,
        }
    },

    methods: {
        updateMlsData(mls_data) {
            this.property_proxy = Object.assign(this.property_proxy, {
                address: mls_data.address,
                city: mls_data.city,
                state: mls_data.state,
                zip: mls_data.zip,
                property_pin: mls_data.property_pin,
            });
        },
    },
}
</script>
